"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _reactBootstrap = require("react-bootstrap");
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
var _imageSrc = require("../../lib/imageSrc");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Renders the MM footer subscribe component
 *
 * @param {object} props sitecore fields Properties used to render the footer subscribe
 *
 * @returns {React.ReactElement} A footer subscribe element
 */
function FooterSubscribe(props) {
  if (!props.fields) return null;
  var socialLinkMediaPadding = props.fields.SubscribeIcon.value ? 'social-links-icon-padding' : props.fields.SubscribeImage.value ? 'social-links-img-padding' : '';
  var SubscribeCTA = () => {
    var {
      linkUrl,
      linkTarget,
      linkAlt
    } = (0, _linkFieldSrc.linkFieldSrc)(props.fields.Link.value);
    if (linkUrl !== '#') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "subscribe-cta align-self-center"
      }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: props.fields.ButtonType.value,
        label: props.fields.Text.value,
        icon: props.fields.ctaIcon.value,
        iconDirection: props.fields.ctaIconPlacement.value,
        linkAlt: linkAlt,
        target: linkTarget,
        dataId: props.fields.ctaDataId.value,
        href: linkUrl
      }));
    } else return null;
  };
  var SubscribeMedia = () => {
    if (props.fields.SubscribeIcon.value) {
      return /*#__PURE__*/_react.default.createElement("picture", {
        class: "align-self-center"
      }, /*#__PURE__*/_react.default.createElement("span", {
        role: "img",
        class: "mm-illustration-buffer ".concat(props.fields.SubscribeIcon.value),
        title: "newsletter subscribe"
      }));
    } else if (props.fields.SubscribeImage.value) {
      return /*#__PURE__*/_react.default.createElement("picture", {
        className: "align-self-center mm-img-square--lg mm-illustration-buffer"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: (0, _imageSrc.imageHref)(props.fields.SubscribeImage.value),
        alt: "newsletter subscribe"
      }));
    } else return null;
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "mm-subscribe-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "row-subscribe"
  }, /*#__PURE__*/_react.default.createElement(SubscribeMedia, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "subscribe-msg"
  }, /*#__PURE__*/_react.default.createElement("h2", null, props.fields.SubscribeTitle.value), /*#__PURE__*/_react.default.createElement("div", null, props.fields.SubscribeMessage.value)), /*#__PURE__*/_react.default.createElement(SubscribeCTA, null))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "social-links ".concat(socialLinkMediaPadding)
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-inline"
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("strong", null, props.fields.SocialMessage.value)), props.fields.SocialLinks.map(social => {
    var {
      linkUrl,
      linkTarget,
      linkAlt
    } = (0, _linkFieldSrc.linkFieldSrc)(social.fields.TargetLink.value);
    return /*#__PURE__*/_react.default.createElement("li", {
      key: social.id
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: linkUrl,
      target: linkTarget,
      rel: "noopener noreferrer",
      "aria-label": linkAlt
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: social.fields.IconName.value
    })));
  }))))));
}
;
var _default = exports.default = FooterSubscribe;